import { imageFromUuid } from '../../helpers/utility';
import malePic from "../../assets/images/patient_male.png";
import femalePic from "../../assets/images/patient_female.png";

const DEFAULT_AVATAR = malePic;
const UNSUPPORTED_IMAGE_KEYS = new Set(['', 'unknown', 'other', 'n/a', 'na', 'null', 'undefined']);
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const ImgHolder = ({ uuid }) => {
    
    const imageKey = typeof uuid === 'string' ? uuid.trim().toLowerCase() : uuid;
    let url = DEFAULT_AVATAR;

    if(imageKey == 'female'){
        url = femalePic
    }
    else if(imageKey == 'male'){
        url = malePic
    }
    else if(typeof uuid === 'string' && !UNSUPPORTED_IMAGE_KEYS.has(imageKey) && UUID_PATTERN.test(uuid.trim())) {
        url = imageFromUuid(uuid);
    }

  return (
    <img src={url} className="h-full w-full rounded-full object-cover" alt="" />
  );
};

export default ImgHolder;